/**
 * @generated SignedSource<<fb505eeac796a265fa1c28cfccde9545>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type groupGrant_issueNavigatorCustomFilters$data = {
  readonly group: {
    readonly name: string;
  } | null | undefined;
  readonly " $fragmentType": "groupGrant_issueNavigatorCustomFilters";
};
export type groupGrant_issueNavigatorCustomFilters$key = {
  readonly " $data"?: groupGrant_issueNavigatorCustomFilters$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupGrant_issueNavigatorCustomFilters">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "groupGrant_issueNavigatorCustomFilters",
  "selections": [
    {
      "concreteType": "JiraGroup",
      "kind": "LinkedField",
      "name": "group",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraShareableEntityGroupGrant"
};

(node as any).hash = "5d137f8bd705292955fe74f248e79b45";

export default node;
